// import content from "containers/Admin/platformAlerts";
import { PlatformAlerts } from "@icons";
import { permissionTypes } from "hooks/usePermissions";
import l from "@loadable/component";

const content = l(() => import("containers/Admin/platformAlerts"));

const { NOTICE_MODAL_CRUD } = permissionTypes;

export default {
  key: "platform-alerts",
  title: "Platform Alerts",
  path: "/platform-alerts/:view?/:tab?/:noticeId?",
  linkTarget: "/platform-alerts",
  linkTitle: "Platform Alerts",
  basePath: "platform-alerts",
  linkCategory: "Admin",
  permission: NOTICE_MODAL_CRUD,
  icon: PlatformAlerts,
  tabs: null,
  content,
  sidebar: null,
};
